import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { getSessionStore } from "app/utils/sessionStore";
import { ContactProfileDetailsContext } from "../macrocomponents/ContactLayout";
import { getTextColorBasedOnBG, hexToRgb, isBgDark } from "../../utils/utils";
import pendingSVG from "../../assets/svg/PendingDark.svg";
import pendingLightSVG from "../../assets/svg/PendingLight.svg";
import educationLightSVG from "../../assets/EducationLight.svg";
import educationDarkSVG from "../../assets/EducationDark.svg";
import proposalsSVG from "../../assets/svg/ProposalsLight.svg";
import proposalsDarkSVG from "../../assets/svg/ProposalsDark.svg";
import plansSVG from "../../assets/svg/PlansDark.svg";
import plansLightSVG from "../../assets/svg/PlansLight.svg";
import { Tooltip } from "primereact/tooltip";
import { THEME } from "app/utils/types";
import useBgBasedTextColor from "app/hooks/useBgBasedTextColor";
import ClientDashboardIcon from "../../assets/IconComponent/ClientDashboardIcon";
import { ReactComponent as AdChat } from "../../assets/svg/Ad-Chat.svg";

function ContactLeftPanelMenuItem({
  name,
  icon,
  directTo,
}: Readonly<{
  name: string;
  icon: string;
  directTo: string;
}>) {
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryColor = "" } = branding ?? {};
  const { isOpen } = useContext(ContactProfileDetailsContext);
  const globalTheme = getSessionStore("globalTheme");
  const color = useBgBasedTextColor();
  document.documentElement.style.setProperty("--cta", primaryColor ? hexToRgb(color) : "0,36,70");

  const showItemIcon = (isActive: boolean) => {
    const chosenIcon = (isActive && isBgDark(color)) || (!isActive && globalTheme === THEME.DARK);
    if (name === "Plans") {
      return (
        <img
          src={chosenIcon ? plansLightSVG : plansSVG}
          data-pc-section="image"
          className="w-[1rem] h-[1rem]"
          alt="plans icon"
        />
      );
    }
    if (name === "Proposals") {
      return (
        <img
          src={chosenIcon ? proposalsSVG : proposalsDarkSVG}
          data-pc-section="image"
          className="w-[1rem] h-[1rem]"
          alt="plans icon"
        />
      );
    }
    if (name === "Pending") {
      return (
        <img
          src={chosenIcon ? pendingLightSVG : pendingSVG}
          data-pc-section="image"
          className="w-[1.4rem] h-[1.4rem]"
          alt="pending icon"
        />
      );
    }
    if (name === "IAPP Academy") {
      return (
        <img
          src={chosenIcon ? educationLightSVG : educationDarkSVG}
          data-pc-section="image"
          className="w-[1rem] h-[1rem]"
          alt="IAPP Academy"
        />
      );
    }
    if (name === "Dashboard") {
      return (
        <ClientDashboardIcon
          fill={
            isActive
              ? getTextColorBasedOnBG(color)
              : !isActive && globalTheme === THEME.DARK
              ? "#ffffff"
              : "#000000"
          }
        />
      );
    }
    if (name === "Chat") {
      return <AdChat style={{ width: "1.2rem", height: "1.2rem" }} />;
    }
    return (
      <i
        className={`pi ${icon}`}
        style={{
          fontSize: "1rem",
          ...(isActive ? { color: getTextColorBasedOnBG(color) } : {}),
        }}
      />
    );
  };

  return (
    <li className="my-2 relative group w-full flex justify-center items-center">
      <NavLink
        to={directTo}
        className={
          ({ isActive }) =>
            `custom-target-icon flex items-center justify-center ${
              isOpen ? "w-full h-full" : "w-[46px] h-[48px]"
            } py-3 rounded-md
        ${isActive ? "text-white" : "hover:bg-gray-100 dark:hover:!bg-gray-800"}`
          // eslint-disable-next-line react/jsx-curly-newline
        }
        style={({ isActive }) => (isActive ? { backgroundColor: color } : {})}
        data-pr-tooltip={name}
      >
        {({ isActive }) => (
          <div className={`flex gap-2 items-center justify-center !bg-transparent `}>
            {showItemIcon(isActive)}
            {isOpen && (
              <span
                className={`text-sm font-semibold text-left ${
                  isOpen ? "w-20" : "w-0 hidden"
                } transition-all overflow-hidden`}
                style={isActive ? { color: getTextColorBasedOnBG(color) } : {}}
              >
                {name}
              </span>
            )}
          </div>
        )}
      </NavLink>
      {!isOpen && <Tooltip target=".custom-target-icon" className="tooltip-wrapper" />}
    </li>
  );
}

export default ContactLeftPanelMenuItem;
